import { render } from "./EditFAQ.vue?vue&type=template&id=c59e0e7a&scoped=true"
import script from "./EditFAQ.vue?vue&type=script&lang=js"
export * from "./EditFAQ.vue?vue&type=script&lang=js"

import "./EditFAQ.vue?vue&type=style&index=0&id=c59e0e7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59e0e7a"],['__file',"src/views/FAQManagement/components/contentComponents/EditFAQ.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c59e0e7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c59e0e7a', __exports__)) {
    api.reload('c59e0e7a', __exports__)
  }
  
  module.hot.accept("./EditFAQ.vue?vue&type=template&id=c59e0e7a&scoped=true", () => {
    api.rerender('c59e0e7a', render)
  })

}


export default __exports__